import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=bbc0c136&scoped=true"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=bbc0c136&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0c136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc0c136')) {
      api.createRecord('bbc0c136', component.options)
    } else {
      api.reload('bbc0c136', component.options)
    }
    module.hot.accept("./roleManage.vue?vue&type=template&id=bbc0c136&scoped=true", function () {
      api.rerender('bbc0c136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/roleManage/roleManage.vue"
export default component.exports